import React, { useState } from "react";
import { LOGO_SRC } from "../data/logo";
export function Logo({
  size = "md"
}: {
  size?: "md" | "sm";
}) {
  const [failed, setFailed] = useState(false);
  const h = size === "sm" ? "h-6" : "h-7";
  return <a href="#top" className="flex items-center gap-2.5" aria-label="Brandhero AI — home" data-id="element-169" data-mp="3qaw40wauq6cf">
      {LOGO_SRC && !failed ? <img src={LOGO_SRC} alt="Brandhero" className={`${h} w-auto`} onError={() => setFailed(true)} data-id="element-170" data-mp="3v8xq7q3kqls4" /> : <span className="logo-gradient font-anton text-[26px] leading-7 tracking-[0.01em]" data-id="element-171" data-mp="mr1jor83bh6c">BRANDHERO</span>}
      <span className="rounded-[2px] bg-signal px-1.5 py-0.5 font-mono text-[12px] leading-4 tracking-[1.5px] text-ink" data-id="element-172" data-mp="dsg3v3u06g99">
        AI
      </span>
    </a>;
}